<template>
  <div id="">

    <v-toolbar dense color="secondary darken-3 d-print-none" flat dark  class="d-print-none">
      <v-toolbar-items>

        <v-btn text icon color="white" @click="moveMonth(-1)">
          <v-icon>chevron_left</v-icon>
        </v-btn>

        <v-btn text icon color="white" @click="moveMonth(1)">
          <v-icon>chevron_right</v-icon>
        </v-btn>

        <v-menu
        offset-y
        v-model="dateMenuMonth"
        :close-on-content-click="false"
        transition="scale-transition"
        full-width
        min-width="290px">

        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text color="white" class="ma-0" >
            <v-icon class="mr-3" :small="isMobile" >today</v-icon>
            {{dateMonthFormated}}
          </v-btn>
        </template>

        <v-date-picker
        color="primary"
        v-model="dates.dateMonth"
        no-title
        type="month"
        locale="es-cl"
        @change="selectMonth()"></v-date-picker>

      </v-menu>




            <!--
          <div v-show="viewSelected == 'remuneraciones'">
            <v-select
            class="mt-1 ml-3"
            v-model="groupSelectedContratistas"
            label="Grupos"
            dense
            flat
            solo-inverted
            hide-details
            single-line
            :items="groupsContratistas"
            item-text="label"
            return-object
            mandatory
            ></v-select>

            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="d-none d-md-flex"
                  text
                  v-on="on"
                  >
                  {{groupSelectedContratistas.label}}
                  <v-icon right>arrow_drop_down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in groupsContratistas"
                  :key="index"
                  @click="groupSelectedContratistas = item" >
                  <v-list-item-title>{{item.label}}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>



          </div>
          -->


          <div style="width: 200px" v-show="viewSelected == 'asistencias'" v-if="!isMobile">
            <!-- <v-select
            class="mt-1 ml-3"
            v-model="variable"
            label="Var"
            dense
            flat
            solo-inverted
            hide-details
            single-line
            :items="optionsVariable"
            item-text="label"
            return-object
            mandatory
            ></v-select> -->
            <v-menu offset-y >
              <template v-slot:activator="{ on }">
                <v-btn
                  class="d-none d-md-flex"
                  text
                  v-on="on"
                  >
                  {{variable.label}}
                  <v-icon right>arrow_drop_down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in optionsVariable"
                  :key="index"
                  @click="variable = item" >
                  <v-list-item-title>{{item.label}}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>


    </v-toolbar-items>

    <v-spacer></v-spacer>

    <v-toolbar-items >

      <!--
          <v-btn-toggle
          v-model="viewSelected"
          color="white"
          group
          tile
          mandatory>
          <v-btn value="remuneraciones" text>
            Remuneraciones
          </v-btn>
          <v-btn value="asistencias" text>
            Asistencias
          </v-btn>
        </v-btn-toggle>
      -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn :x-small="isMobile" text icon color="white" @click="print()">
                <v-icon>print</v-icon>
              </v-btn>

            </template>
            <span>Imprimir</span>
          </v-tooltip>


          <v-tooltip bottom v-if="viewSelected == 'remuneraciones'" >
            <template v-slot:activator="{ on, attrs }">
              <v-btn :x-small="isMobile" text icon color="white" @click="downloadXls()" >
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span>Descargar Excel</span>
          </v-tooltip>


          <v-btn :x-small="isMobile" text icon color="white" @click="downloadAsistencia()" v-if="viewSelected == 'asistencias'" :loading="loadingDownload">
            <v-icon>cloud_download</v-icon>
          </v-btn>

          <v-btn v-if="!isMobile" @click="viewSelected = 'remuneraciones'" text :input-value="viewSelected == 'remuneraciones'">
            Remuneraciones
          </v-btn>
          <v-btn v-if="!isMobile" @click="viewSelected = 'asistencias'" text :input-value="viewSelected == 'asistencias'">
            Asistencias
          </v-btn>


    </v-toolbar-items>
  </v-toolbar>







  <v-toolbar color="primary darken-1" dark v-if="isMobile" :height="40" class="d-print-none">
    <v-toolbar-items>

          <v-btn x-small @click="viewSelected = 'remuneraciones'" text :input-value="viewSelected == 'remuneraciones'">
            Remuneraciones
          </v-btn>
          <v-btn x-small @click="viewSelected = 'asistencias'" text :input-value="viewSelected == 'asistencias'">
            Asistencias
          </v-btn>

    </v-toolbar-items>
  </v-toolbar>




  <div class="d-print-flex d-none justify-space-between header-print">
    <div>
      Mes: {{dateMonthFormatedPrint}}
    </div >
  </div >




  <div v-if="trabajadores.length > 0">

    <libro-remuneraciones
      ref="libroRemuneraciones"
      v-if="viewSelected == 'remuneraciones'"
      :key="dates.dateInicio.unix()+'_libro-remuneraciones'"
      :dates="dates"
      :contratistas="contratistas"
      :trabajadores="trabajadores"
    ></libro-remuneraciones>

    <asistencia
      v-if="viewSelected == 'asistencias'"
      :key="dates.dateInicio.unix()+'_asistencia'"
      :dates="dates"
      :trabajadores="trabajadores"
      :variable="variable"
    ></asistencia>

  </div>


</div>
</template>
<script>


import _ from "lodash";
import moment from "moment";
import trabajadorModel from "@/models/trabajadorModel";
import contratistaModel from "@/models/contratistaModel";
import asistencia from "@/views/asistencia"
import libroRemuneraciones from "@/views/libroRemuneraciones"
import Repository from "@/models/repoIrricrops";

export default {
  name: "Remuneraciones",
  components: {
    asistencia,
    libroRemuneraciones
  },
  data: () => ({
    trabajadores : [],
    contratistas: [],
    viewSelected : 'remuneraciones',
    loadingDownload : false,
    dates        : {
      dateInicio  : moment().startOf('month'),
      dateFin     : moment().endOf('month'),
      dateMonth   : moment().startOf('month').format("YY-MM"),
    },
    dateMenuMonth : false,
    variable               : null,
    optionsVariable        : [
      {label:"Jornadas", var:"jornada"},
      {label:"Costos", var:"valor_total", formated:"currency"},
      {label:"Bonos", var:"bono", formated:"currency"},
    ],
    /*
    groupsContratistas: [
      {label:"Todos", path:"total"},
      {label:"Empresa", path:"empresa"},
      {label:"por contratista", path:"contratista", hasMany: true},
    ],
    groupSelectedContratistas: null,
    */
  }),
  computed:{
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
    isMobile(){
      return this.$store.getters.isMobile;
    },
    dateMonthFormated(){
      return moment(this.dates.dateMonth+"-01", "YY-MM-DD").format("MMM");
    },
    dateMonthFormatedPrint(){
      return moment(this.dates.dateMonth+"-01", "YY-MM-DD").format("MMMM YYYY");
    },
    /*
    datesFormated(){
      return {
        dateInicio : this.dates.dateInicio.format("YYYY-MM-DD"),
        dateFin    : this.dates.dateFin.format("YYYY-MM-DD"),
        dateMonth  : this.dateMonth
      }
    }
    */
  },
  watch:{
    empresaSelected(){
      this.getTrabajadores();
      this.getContratistas();
    }
  },
  mounted() {
    this.getTrabajadores();
    this.getContratistas();
  },
  created() {
    //do something after creating vue instance
    this.variable = _.first(this.optionsVariable);
    //this.groupSelectedContratistas = _.first(this.groupsContratistas);
  },
  methods: {

    moveMonth(cant){
      this.dates.dateInicio = this.dates.dateInicio.add(cant, "month");
      this.dates.dateFin    = this.dates.dateFin.add(cant, "month").endOf("month");
      this.dates.dateMonth  = moment(this.dates.dateMonth+"-01", "YY-MM-DD").add(cant, "month").format("YY-MM");
      /*
      this.changeDates({
        dateInicio : this.dates.dateInicio,
        dateFin    : this.dates.dateFin,
      })
      */
    },

    selectMonth(){
      this.dates.dateInicio = moment(this.dates.dateMonth+"-01", "YY-MM-DD");
      this.dates.dateFin    = moment(this.dates.dateMonth+"-01", "YY-MM-DD").endOf("month");
      this.dateMenuMonth    = false;
      /*
      this.changeDates({
        dateInicio : this.dates.dateInicio,
        dateFin    : this.dates.dateFin,
      })
      */
    },

    /*
    changeDates(dates){
      this.datesDialog  = {
        dateInicio : dates.dateInicio.format("YYYY-MM-DD"),
        dateFin    : dates.dateFin.format("YYYY-MM-DD")
        //dateMonth  : dates.dateInicio.format("YY-MM")
      };
      this.dateSelected = dates.dateInicio.format("YYYY-MM-DD")
    },
    */

    getTrabajadores(){
      if(this.empresaSelected == null) return;
      var p = trabajadorModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }});
      p.then(res => {
        this.trabajadores = res.data.data;
        _.forEach(this.trabajadores, tr => {
          tr.codname = tr.nombre;
          if(tr.codigo && tr.codigo.length > 1){
            tr.codname = tr.codigo;
          }
        })
      }, resError =>{
        console.error(resError);
      });
      return p;
    },



    getContratistas(){
      if(this.empresaSelected == null) return;

      return  contratistaModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }}).then(res => {
        this.contratistas = res.data.data;
      }, resError =>{
        console.error(resError);
      });
    },



    print(){
      var containers = document.getElementsByClassName("container-tl");
      _.forEach(containers, c => {
        c.scrollLeft = 0;
      });
      window.print();
    },




    downloadAsistencia(){
      this.loadingDownload = true;
      Repository.get('/export/asistencias/',{
        params:{
          empresa_id   : this.empresaSelected.id,
          filtrar      : true,
          fecha_inicio : this.dates.dateInicio.format("YYYY-MM-DD"),
          fecha_fin    : this.dates.dateFin.format("YYYY-MM-DD")
        },
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.loadingDownload = false;
        this.forceFileDownload(response)
      },function(resError){
        this.loadingUpload = false;
        this.$store.commit("showSnackBar", resError.message);
        console.log('FAILURE!!');
      })
      .catch((error) => {
        debugger;
        console.log('error occured')
      })
    },

    downloadXls(){
      this.$refs.libroRemuneraciones.downloadXls("Remuneraciones");
    },


    forceFileDownload(response){
      const url  = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href  = url
      link.setAttribute('download', this.empresaSelected.nombre + '.xlsx')
      document.body.appendChild(link)
      link.click()
    },

  }
}
</script>
<style lang="scss" scoped>
.header-print{
  margin: 8px 8px 16px 8px;
}
</style>
